import { useEffect, useCallback } from 'react';
import { prop } from 'ramda';
import { useDispatch } from 'react-redux';
import { usePushSubscription, useGetPlayerTags } from 'server';
import { usePrevious } from 'js/hooks/usePrevious';
import { getLocationParams } from 'js/utils/url.util';
import { useUserSelector } from 'js/store/hooks';
import { storageService } from 'js/services/storage.service';

import { depositReachedThresholdPopupAction } from '../../../../../popups/DepositReachedThresholdPopup';

const TAG_NAME = 'depositThresholdConfirmation';

export const useDepositReachedThresholdNotification = () => {
    const { isNative: isNativeGetParam } = getLocationParams();
    const popupsDispatch = useDispatch();
    const getPlayerTags = useGetPlayerTags();
    const isLoggedIn = useUserSelector(prop('isLoggedIn'));
    const wasLoggedIn = usePrevious(isLoggedIn);
    const isNative = storageService.session.getItem('isNative') || isNativeGetParam === '1';

    const handlePushMessage = useCallback(pushMessage => {
        if (pushMessage.ID !== 31133 || isNative) {
            return;
        }

        const { notification: { notificationPlayerTagChangeInfo } = {} } = pushMessage.data;

        if (!notificationPlayerTagChangeInfo) {
            return;
        }

        const { tag, value } = notificationPlayerTagChangeInfo;

        if (tag !== TAG_NAME || value !== 'required') {
            return;
        }

        popupsDispatch(depositReachedThresholdPopupAction());
    }, [popupsDispatch, isNative]);

    usePushSubscription(31133, () => handlePushMessage);

    useEffect(() => {
        if (isLoggedIn && !wasLoggedIn && !isNative) {
            (async function() {
                const response = await getPlayerTags({ tagName: TAG_NAME });
                const tags = response?.tags || [];

                if (!tags.length) {
                    return;
                }

                const tag = tags[0];

                if (tag.name !== TAG_NAME || tag.value !== 'required') {
                    return;
                }

                popupsDispatch(depositReachedThresholdPopupAction());
            })();
        }
    }, [isLoggedIn, wasLoggedIn, popupsDispatch, isNative, getPlayerTags]);
};
